var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var UnorderedList = function UnorderedList(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 30 30' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M13 23h10v-2H13v2zm-5 0h3v-3H8v3zm0-6h3v-3H8v3zm0-6h3V8H8v3zm5 0h10V9H13v2zm0 6h10v-2H13v2z' })
    )
  );
};
/*eslint-enable */

export default UnorderedList;
//# sourceMappingURL=UnorderedList.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/UnorderedList.js